var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(parseInt(_vm.pvtype) === 1)?_c('div',[_vm._v("浏览量："+_vm._s(_vm.count))]):_vm._e(),_vm._v(" "),(parseInt(_vm.pvtype) === 2)?_c('div',{class:[_vm.pvStyle]},[_c('i',{staticClass:"icon"}),(_vm.count !== 0)?_c('span',{staticClass:"desc"},[_vm._v(_vm._s(_vm.count))]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-641bc5ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/amount/pv.vue
// module id = null
// module chunks = 